import { render } from "./MessagesList.vue?vue&type=template&id=82031d28&scoped=true"
import script from "./MessagesList.vue?vue&type=script&lang=js"
export * from "./MessagesList.vue?vue&type=script&lang=js"

import "./MessagesList.vue?vue&type=style&index=0&id=82031d28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82031d28"]])

export default __exports__